export const EXAMPLE_ACTION = "EXAMPLE_ACTION";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const CLEAR_DATA_SUCCESS = "CLEAR_DATA_SUCCESS";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

export const FETCH_LOCATION_REQUEST = "FETCH_LOCATION_REQUEST";
export const FETCH_LOCATION_SUCCESS = "FETCH_LOCATION_SUCCESS";
export const FETCH_LOCATION_FAILURE = "FETCH_LOCATION_FAILURE";

export const FETCH_DISTRICT_LOCATION_REQUEST =
  "FETCH_DISTRICT_LOCATION_REQUEST";
export const FETCH_DISTRICT_LOCATION_SUCCESS =
  "FETCH_DISTRICT_LOCATION_SUCCESS";
export const FETCH_DISTRICT_LOCATION_FAILURE =
  "FETCH_DISTRICT_LOCATION_FAILURE";

export const FETCH_CONTRIBUTION_PLAN_REQUEST =
  "FETCH_CONTRIBUTION_PLAN_REQUEST";
export const FETCH_CONTRIBUTION_PLAN_SUCCESS =
  "FETCH_CONTRIBUTION_PLAN_SUCCESS";
export const FETCH_CONTRIBUTION_PLAN_FAILURE =
  "FETCH_CONTRIBUTION_PLAN_FAILURE";

export const FETCH_CONTRIBUTIONBYID_PLAN_REQUEST =
  "FETCH_CONTRIBUTIONBYID_PLAN_REQUEST";
export const FETCH_CONTRIBUTIONBYID_PLAN_SUCCESS =
  "FETCH_CONTRIBUTIONBYID_PLAN_SUCCESS";
export const FETCH_CONTRIBUTIONBYID_PLAN_FAILURE =
  "FETCH_CONTRIBUTIONBYID_PLAN_FAILURE";

export const LOGIN_DATA_REQUEST = "LOGIN_DATA_REQUEST";
export const LOGIN_DATA_SUCCESS = "LOGIN_DATA_SUCCESS";
export const LOGIN_DATA_FAILURE = "LOGIN_DATA_FAILURE";

export const FORGOT_DATA_REQUEST = "FORGOT_DATA_REQUEST";
export const FORGOT_DATA_SUCCESS = "FORGOT_DATA_SUCCESS";
export const FORGOT_DATA_FAILURE = "FORGOT_DATA_FAILURE";

export const RESET_DATA_REQUEST = "RESET_DATA_REQUEST";
export const RESET_DATA_SUCCESS = "RESET_DATA_SUCCESS";
export const RESET_DATA_FAILURE = "RESET_DATA_FAILURE";

export const CURRENTUSER_DATA_REQUEST = "CURRENTUSER_DATA_REQUEST";
export const CURRENTUSER_DATA_SUCCESS = "CURRENTUSER_DATA_SUCCESS";
export const CURRENTUSER_DATA_FAILURE = "CURRENTUSER_DATA_FAILURE";

export const CURRENt_USER_WITH_ROLES_SUCCESS = "CURRENt_USER_WITH_ROLES_SUCCESS";

export const REFRESH_TOKEN_DATA_REQUEST = "REFRESH_TOKEN_DATA_REQUEST";
export const REFRESH_TOKEN_DATA_SUCCESS = "REFRESH_TOKEN_DATA_SUCCESS";
export const REFRESH_TOKEN_DATA_FAILURE = "REFRESH_TOKEN_DATA_FAILURE";

export const FETCH_POLICYHOLDER_USER_REQUEST =
  "FETCH_POLICYHOLDER_USER_REQUEST";
export const FETCH_POLICYHOLDER_USER_SUCCESS =
  "FETCH_POLICYHOLDER_USER_SUCCESS";
export const FETCH_POLICYHOLDER_USER_FAILURE =
  "FETCH_POLICYHOLDER_USER_FAILURE";

export const FETCH_MUNICIPALITY_LOCATION_REQUEST =
  "FETCH_MUNICIPALITY_LOCATION_REQUEST";
export const FETCH_MUNICIPALITY_LOCATION_SUCCESS =
  "FETCH_MUNICIPALITY_LOCATION_SUCCESS";
export const FETCH_MUNICIPALITY_LOCATION_FAILURE =
  "FETCH_MUNICIPALITY_LOCATION_FAILURE";

export const FETCH_ALL_LOCATION_REQUEST = "FETCH_ALL_LOCATION_REQUEST";
export const FETCH_ALL_LOCATION_SUCCESS = "FETCH_ALL_LOCATION_SUCCESS";
export const FETCH_ALL_LOCATION_FAILURE = "FETCH_ALL_LOCATION_FAILURE";

export const FETCH_VILLAGE_LOCATION_REQUEST = "FETCH_VILLAGE_LOCATION_REQUEST";
export const FETCH_VILLAGE_LOCATION_SUCCESS = "FETCH_VILLAGE_LOCATION_SUCCESS";
export const FETCH_VILLAGE_LOCATION_FAILURE = "FETCH_VILLAGE_LOCATION_FAILURE";

export const FETCH_INSUREEBYID_REQUEST = "FETCH_INSUREEBYID_REQUEST";
export const FETCH_INSUREEBYID_SUCCESS = "FETCH_INSUREEBYID_SUCCESS";
export const FETCH_INSUREEBYID_FAILURE = "FETCH_INSUREEBYID_FAILURE";

export const FETCH_POLICYHOLDERINSUREE_REQUEST =
  "FETCH_POLICYHOLDERINSUREE_REQUEST";
export const FETCH_POLICYHOLDERINSUREE_SUCCESS =
  "FETCH_POLICYHOLDERINSUREE_SUCCESS";
export const FETCH_POLICYHOLDERINSUREE_FAILURE =
  "FETCH_POLICYHOLDERINSUREE_FAILURE";

export const CREATE_POLICYHOLDERINSUREECREATE_REQUEST =
  "CREATE_POLICYHOLDERINSUREECREATE_REQUEST";
export const CREATE_POLICYHOLDERINSUREECREATE_SUCCESS =
  "CREATE_POLICYHOLDERINSUREECREATE_SUCCESS";
export const CREATE_POLICYHOLDERINSUREECREATE_FAILURE =
  "CREATE_POLICYHOLDERINSUREECREATE_FAILURE";

export const UPDATE_POLICYHOLDERINSUREEUPDATE_REQUEST =
  "UPDATE_POLICYHOLDERINSUREEUPDATE_REQUEST";
export const UPDATE_POLICYHOLDERINSUREEUPDATE_SUCCESS =
  "UPDATE_POLICYHOLDERINSUREEUPDATE_SUCCESS";
export const UPDATE_POLICYHOLDERINSUREEUPDATE_FAILURE =
  "UPDATE_POLICYHOLDERINSUREEUPDATE_FAILURE";

export const DELETE_POLICYHOLDERINSUREEDELETE_REQUEST =
  "DELETE_POLICYHOLDERINSUREEDELETE_REQUEST";
export const DELETE_POLICYHOLDERINSUREEDELETE_SUCCESS =
  "DELETE_POLICYHOLDERINSUREEDELETE_SUCCESS";
export const DELETE_POLICYHOLDERINSUREEDELETE_FAILURE =
  "DELETE_POLICYHOLDERINSUREEDELETE_FAILURE";

export const PRINT_INSUREE_REQUEST = "PRINT_INSUREE_REQUEST";
export const PRINT_INSUREE_SUCCESS = "PRINT_INSUREE_SUCCESS";
export const PRINT_INSUREE_FAILURE = "PRINT_INSUREE_FAILURE";
export const CLEAR_PRINT_INSUREE = "CLEAR_PRINT_INSUREE";

export const CORE_MUTATION_RESP = "CORE_MUTATION_RESP";

export const DOCUMENT_FILE_RESP = "DOCUMENT_FILE_RESP";
export const DOCUMENT_DOCUMENTS_RESP = "DOCUMENT_DOCUMENTS_RESP";
export const TEMPLATE_FILE_RESP = "TEMPLATE_FILE_RESP";

export const FETCH_PAYEMTS_REQUEST = "FETCH_PAYEMTS_REQUEST";
export const FETCH_PAYEMTS_SUCCESS = "FETCH_PAYEMTS_SUCCESS";
export const FETCH_PAYEMTS_FAILURE = "FETCH_PAYEMTS_FAILURE";

export const FETCH_PAYEMTSBYID_REQUEST = "FETCH_PAYEMTSBYID_REQUEST";
export const FETCH_PAYEMTSBYID_SUCCESS = "FETCH_PAYEMTSBYID_SUCCESS";
export const FETCH_PAYEMTSBYID_FAILURE = "FETCH_PAYEMTSBYID_FAILURE";

export const UPLOAD_FILE_RESP = "UPLOAD_FILE_RESP";

export const DELETE_FILE_RESP = "DELETE_FILE_RESP";

export const FETCH_CONTRACT_REQUEST = "FETCH_CONTRACT_REQUEST";
export const FETCH_CONTRACT_SUCCESS = "FETCH_CONTRACT_SUCCESS";
export const FETCH_CONTRACT_FAILURE = "FETCH_CONTRACT_FAILURE";

export const FETCH_ENDATE_REQUEST = "FETCH_ENDATE_REQUEST";
export const FETCH_ENDATE_SUCCESS = "FETCH_ENDATE_SUCCESS";
export const FETCH_ENDATE_FAILURE = "FETCH_ENDATE_FAILURE";

export const FETCH_CREATE_CONTRACT_REQUEST = "FETCH_CREATE_CONTRACT_REQUEST";
export const FETCH_CREATE_CONTRACT_SUCCESS = "FETCH_CREATE_CONTRACT_SUCCESS";
export const FETCH_CREATE_CONTRACT_FAILURE = "FETCH_CREATE_CONTRACT_FAILURE";

export const FETCH_CONTRACT_DETAILS_REQUEST = "FETCH_CONTRACT_DETAILS_REQUEST";
export const FETCH_CONTRACT_DETAILS_SUCCESS = "FETCH_CONTRACT_DETAILS_SUCCESS";
export const FETCH_CONTRACT_DETAILS_FAILURE = "FETCH_CONTRACT_DETAILS_FAILURE";

export const FETCH_POLICYHOLDER_INSUREE_REQUEST =
  "FETCH_POLICYHOLDER_INSUREE_REQUEST";
export const FETCH_POLICYHOLDER_INSUREE_SUCCESS =
  "FETCH_POLICYHOLDER_INSUREE_SUCCESS";
export const FETCH_POLICYHOLDER_INSUREE_FAILURE =
  "FETCH_POLICYHOLDER_INSUREE_FAILURE";

export const FETCH_CONTRACT_DELETE_REQUEST = "FETCH_CONTRACT_DELETE_REQUEST";
export const FETCH_CONTRACT_DELETE_SUCCESS = "FETCH_CONTRACT_DELETE_SUCCESS";
export const FETCH_CONTRACT_DELETE_FAILURE = "FETCH_CONTRACT_DELETE_FAILURE";

export const UPDATE_PAYMENT_REQUEST = "UPDATE_PAYMENT_REQUEST";
export const UPDATE_PAYMENT_SUCCESS = "UPDATE_PAYMENT_SUCCESS";
export const UPDATE_PAYMENT_FAILURE = "UPDATE_PAYMENT_FAILURE";

export const SUBMIT_CONTRACT_REQUEST = "SUBMIT_CONTRACT_REQUEST";
export const SUBMIT_CONTRACT_SUCCESS = "SUBMIT_CONTRACT_SUCCESS";
export const SUBMIT_CONTRACT_FAILURE = "SUBMIT_CONTRACT_FAILURE";

export const DELETE_CONTRACT_DETAIL_REQUEST = "DELETE_CONTRACT_DETAIL_REQUEST";
export const DELETE_CONTRACT_DETAIL_SUCCESS = "DELETE_CONTRACT_DETAIL_SUCCESS";
export const DELETE_CONTRACT_DETAIL_FAILURE = "DELETE_CONTRACT_DETAIL_FAILURE";

export const INITIALIZE_ROUTES = "INITIALIZE_ROUTES";

export const FETCH_USER_VALIDATION_REQUEST = "FETCH_USER_VALIDATION_REQUEST";
export const FETCH_USER_VALIDATION_SUCCESS = "FETCH_USER_VALIDATION_SUCCESS";
export const FETCH_USER_VALIDATION_FAILURE = "FETCH_USER_VALIDATION_FAILURE";

export const PRINT_POLICYHOLDER_REQUEST = "PRINT_POLICYHOLDER_REQUEST";
export const PRINT_POLICYHOLDER_SUCCESS = "PRINT_POLICYHOLDER_SUCCESS";
export const PRINT_POLICYHOLDER_FAILURE = "PRINT_POLICYHOLDER_FAILURE";

export const FETCH_VERIFICATION_DATA_REQUEST = "PRINT_POLICYHOLDER_REQUEST";
export const FETCH_VERIFICATION_DATA_SUCCESS = "PRINT_POLICYHOLDER_SUCCESS";
export const FETCH_VERIFICATION_DATA_FAILURE = "PRINT_POLICYHOLDER_FAILURE";

export const FETCH_VERIFICATION_CODE_REQUEST =
  "FETCH_VERIFICATION_CODE_REQUEST";
export const FETCH_VERIFICATION_CODE_SUCCESS =
  "FETCH_VERIFICATION_CODE_SUCCESS";
export const FETCH_VERIFICATION_CODE_FAILURE =
  "FETCH_VERIFICATION_CODE_FAILURE";
export const CLEAN_VERIFICATION_CODE = 
  "CLEAN_VERIFICATION_CODE";
export const CLEAN_SELECTED_INSUREE = 
  "CLEAN_SELECTED_INSUREE";

export const FETCH_HEALTH_FACILITIES_REQUEST =
  "FETCH_HEALTH_FACILITIES_REQUEST";
export const FETCH_HEALTH_FACILITIES_SUCCESS =
  "FETCH_HEALTH_FACILITIES_SUCCESS";
export const FETCH_HEALTH_FACILITIES_FAILURE =
  "FETCH_HEALTH_FACILITIES_FAILURE";

export const FETCH_CONVENTIONNEMENT_BY_HF_ID_REQUEST =
  "FETCH_CONVENTIONNEMENT_BY_HF_ID_REQUEST";
export const FETCH_CONVENTIONNEMENT_BY_HF_ID_SUCCESS =
  "FETCH_CONVENTIONNEMENT_BY_HF_ID_SUCCESS";
export const FETCH_CONVENTIONNEMENT_BY_HF_ID_FAILURE =
  "FETCH_CONVENTIONNEMENT_BY_HF_ID_FAILURE";

export const FETCH_HEALTH_FACILITIES_PACKAGE_REQUEST =
  "FETCH_HEALTH_FACILITIES_PACKAGE_REQUEST";
export const FETCH_HEALTH_FACILITIES_PACKAGE_SUCCESS =
  "FETCH_HEALTH_FACILITIES_PACKAGE_SUCCESS";
export const FETCH_HEALTH_FACILITIES_PACKAGE_FAILURE =
  "FETCH_HEALTH_FACILITIES_PACKAGE_FAILURE";

export const FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_REQUEST =
  "FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_REQUEST";
export const FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_SUCCESS =
  "FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_SUCCESS";
export const FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_FAILURE =
  "FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_FAILURE";

export const FETCH_HEALTH_FACILITIES_INUSREE_REQUEST =
  "FETCH_HEALTH_FACILITIES_INUSREE_REQUEST";
export const FETCH_HEALTH_FACILITIES_INUSREE_SUCCESS =
  "FETCH_HEALTH_FACILITIES_INUSREE_SUCCESS";
export const FETCH_HEALTH_FACILITIES_INUSREE_FAILURE =
  "FETCH_HEALTH_FACILITIES_INUSREE_FAILURE";

export const FETCH_HEALTH_FACILITIES_INUSREE_STATUS_REQUEST =
  "FETCH_HEALTH_FACILITIES_INUSREE_STATUS_REQUEST";
export const FETCH_HEALTH_FACILITIES_INUSREE_STATUS_SUCCESS =
  "FETCH_HEALTH_FACILITIES_INUSREE_STATUS_SUCCESS";
export const FETCH_HEALTH_FACILITIES_INUSREE_STATUS_FAILURE =
  "FETCH_HEALTH_FACILITIES_INUSREE_STATUS_FAILURE";

export const FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_REQUEST = "FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_REQUEST"
export const FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_SUCCESS = "FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_SUCCESS"
export const FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_FAILURE = "FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_FAILURE"

export const FETCH_VERIFICATION_HISTORY_REQUEST =
  "FETCH_VERIFICATION_HISTORY_REQUEST";
export const FETCH_VERIFICATION_HISTORY_SUCCESS =
  "FETCH_VERIFICATION_HISTORY_SUCCESS";
export const FETCH_VERIFICATION_HISTORY_FAILURE =
  "FETCH_VERIFICATION_HISTORY_FAILURE";

export const FETCH_POLICIES_INSUREE_REQUEST = "FETCH_POLICIES_INSUREE_REQUEST";
export const FETCH_POLICIES_INSUREE_SUCCESS = "FETCH_POLICIES_INSUREE_SUCCESS";
export const FETCH_POLICIES_INSUREE_FAILURE = "FETCH_POLICIES_INSUREE_FAILURE";

export const FETCH_LATEST_ACTIVE_INSUREE_REQUEST =
  "FETCH_LATEST_ACTIVE_INSUREE_REQUEST";
export const FETCH_LATEST_ACTIVE_INSUREE_SUCCESS =
  "FETCH_LATEST_ACTIVE_INSUREE_SUCCESS";
export const FETCH_LATEST_ACTIVE_INSUREE_FAILURE =
  "FETCH_LATEST_ACTIVE_INSUREE_FAILURE";

export const FETCH_GUARDIAN_REQUEST = "FETCH_GUARDIAN_REQUEST";
export const FETCH_GUARDIAN_SUCCESS = "FETCH_GUARDIAN_SUCCESS";
export const FETCH_GUARDIAN_FAILURE = "FETCH_GUARDIAN_FAILURE";

export const FETCH_CONSULTANT_HF_REQUEST = "FETCH_CONSULTANT_HF_REQUEST";
export const FETCH_CONSULTANT_HF_SUCCESS = "FETCH_CONSULTANT_HF_SUCCESS";
export const FETCH_CONSULTANT_HF_FAILURE = "FETCH_CONSULTANT_HF_FAILURE";

export const FETCH_PRINT_CARE_SHEET_REQUEST = "FETCH_PRINT_CARE_SHEET_REQUEST";
export const FETCH_PRINT_CARE_SHEET_SUCCESS = "FETCH_PRINT_CARE_SHEET_SUCCESS";
export const FETCH_PRINT_CARE_SHEET_FAILURE = "FETCH_PRINT_CARE_SHEET_FAILURE";
export const CLEAR_CARESHEET_DATA = "CLEAR_CARESHEET_DATA";

export const CREATE_FOSA_USER_REQUEST = "CREATE_FOSA_USER_REQUEST";
export const CREATE_FOSA_USER_SUCCESS = "CREATE_FOSA_USER_SUCCESS";
export const CREATE_FOSA_USER_FAILURE = "CREATE_FOSA_USER_FAILURE";

export const FETCH_CLAIM_TABLE_REQUEST = "FETCH_CLAIM_TABLE_REQUEST";
export const FETCH_CLAIM_TABLE_SUCCESS = "FETCH_CLAIM_TABLE_SUCCESS";
export const FETCH_CLAIM_TABLE_FAILURE = "FETCH_CLAIM_TABLE_FAILURE";

// get roles 
export const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";

//  ADMIN TABLE
export const FETCH_ADMIN_TABLE_REQUEST = "FETCH_ADMIN_TABLE_REQUEST";
export const FETCH_ADMIN_TABLE_SUCCESS = "FETCH_ADMIN_TABLE_SUCCESS";
export const FETCH_ADMIN_TABLE_FAILURE = "FETCH_ADMIN_TABLE_FAILURE";

export const FETCH_ADMIN_REQUEST = "FETCH_ADMIN_REQUEST";
export const FETCH_ADMIN_SUCCESS = "FETCH_ADMIN_SUCCESS";
export const FETCH_ADMIN_FAILURE = "FETCH_ADMIN_FAILURE";

export const RESET_USERNAME_ERROR = "RESET_USERNAME_ERROR";

export const EDIT_ADMIN_REQUEST = "EDIT_ADMIN_REQUEST";
export const EDIT_ADMIN_SUCCESS = "EDIT_ADMIN_SUCCESS";
export const EDIT_ADMIN_FAILURE = "EDIT_ADMIN_FAILURE";

export const CREATE_ADMIN_REQUEST = "CREATE_ADMIN_REQUEST";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_ADMIN_FAILURE = "CREATE_ADMIN_FAILURE";

export const DELETE_ADMIN_REQUEST = "DELETE_ADMIN_REQUEST";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_FAILURE = "DELETE_ADMIN_FAILURE";
// ADMIN TABLE

export const FETCH_CLAIM_SERVICE_REQUEST = "FETCH_CLAIM_SERVICE_REQUEST";
export const FETCH_CLAIM_SERVICE_SUCCESS = "FETCH_CLAIM_SERVICE_SUCCESS";
export const FETCH_CLAIM_SERVICE_FAILURE = "FETCH_CLAIM_SERVICE_FAILURE";

export const FETCH_CLAIM_ITEMS_REQUEST = "FETCH_CLAIM_ITEMS_REQUEST";
export const FETCH_CLAIM_ITEMS_SUCCESS = "FETCH_CLAIM_ITEMS_SUCCESS";
export const FETCH_CLAIM_ITEMS_FAILURE = "FETCH_CLAIM_ITEMS_FAILURE";


export const FETCH_PATHOLOGY_REQUEST = "FETCH_PATHOLOGY_REQUEST";
export const FETCH_PATHOLOGY_SUCCESS = "FETCH_PATHOLOGY_SUCCESS";
export const FETCH_PATHOLOGY_FAILURE = "FETCH_PATHOLOGY_FAILURE";

export const CREATE_CLAIM_REQUEST = "CREATE_CLAIM_REQUEST";
export const CREATE_CLAIM_SUCCESS = "CREATE_CLAIM_SUCCESS";
export const CREATE_CLAIM_FAILURE = "CREATE_CLAIM_FAILURE";

export const FETCH_CLAIMBYID_REQUEST = "FETCH_CLAIMBYID_REQUEST";
export const FETCH_CLAIMBYID_SUCCESS = "FETCH_CLAIMBYID_SUCCESS";
export const FETCH_CLAIMBYID_FAILURE = "FETCH_CLAIMBYID_FAILURE";
export const CLEAR_CLAIM_RESP = "CLEAR_CLAIM_RESP"

export const FETCH_CLAIMHISTORYBYID_REQUEST = "FETCH_CLAIMHISTORYBYID_REQUEST";
export const FETCH_CLAIMHISTORYBYID_SUCCESS = "FETCH_CLAIMHISTORYBYID_SUCCESS";
export const FETCH_CLAIMHISTORYBYID_FAILURE = "FETCH_CLAIMHISTORYBYID_FAILURE";

export const FETCH_ADMINID_REQUEST = "FETCH_ADMINID_REQUEST";
export const FETCH_ADMINID_SUCCESS = "FETCH_ADMINID_SUCCESS";
export const FETCH_ADMINID_FAILURE = "FETCH_ADMINID_FAILURE";

export const FETCH_INSUREEUUID_REQUEST = "FETCH_INSUREEUUID_REQUEST";
export const FETCH_INSUREEUUID_SUCCESS = "FETCH_INSUREEUUID_SUCCESS";
export const FETCH_INSUREEUUID_FAILURE = "FETCH_INSUREEUUID_FAILURE";

export const FETCH_SUBSTITUTE_SUCCESS = "FETCH_SUBSTITUTE_SUCCESS";
export const FETCH_SUBSTITUTE_FAILURE = "FETCH_SUBSTITUTE_FAILURE";
export const FETCH_SUBSTITUTE_REQUEST = "FETCH_SUBSTITUTE_REQUEST";

export const SUBMIT_CLAIM_REQUEST = "SUBMIT_CLAIM_REQUEST";
export const SUBMIT_CLAIM_SUCCESS = "SUBMIT_CLAIM_SUCCESS";
export const SUBMIT_CLAIM_FAILURE = "SUBMIT_CLAIM_FAILURE";
export const RESET_CLAIM_STATE = "RESET_CLAIM_STATE";

export const UPDATE_CLAIM_REQUEST = "UPDATE_CLAIM_REQUEST";
export const UPDATE_CLAIM_SUCCESS = "UPDATE_CLAIM_SUCCESS";
export const UPDATE_CLAIM_FAILURE = "UPDATE_CLAIM_FAILURE";

export const CREATE_ATTACHMENT_REQUEST = "CREATE_ATTACHMENT_REQUEST";
export const CREATE_ATTACHMENT_SUCCESS = "CREATE_ATTACHMENT_SUCCESS";
export const CREATE_ATTACHMENT_FAILURE = "CREATE_ATTACHMENT_FAILURE";


export const FETCH_ATTACHEMENTS_REQUEST = "FETCH_ATTACHEMENTS_REQUEST";
export const FETCH_ATTACHEMENTS_SUCCESS = "FETCH_ATTACHEMENTS_SUCCESS";
export const FETCH_ATTACHEMENTS_FAILURE = "FETCH_ATTACHEMENTS_FAILURE";
export const FETCH_MEDICAL_INSUREE_REQUEST = "FETCH_MEDICAL_INSUREE_REQUEST";
export const FETCH_MEDICAL_INSUREE_SUCCESS = "FETCH_MEDICAL_INSUREE_SUCCESS";
export const FETCH_MEDICAL_INSUREE_FAILURE = "FETCH_MEDICAL_INSUREE_FAILURE";

export const GET_CONSULTANT_REQUEST = "GET_CONSULTANT_REQUEST";
export const GET_CONSULTANT_SUCCESS = "GET_CONSULTANT_SUCCESS";
export const GET_CONSULTANT_FAILURE = "GET_CONSULTANT_FAILURE";

export const FETCH_FOSA_USER_REQUEST = "FETCH_FOSA_USER_REQUEST";
export const FETCH_FOSA_USER_SUCCESS = "FETCH_FOSA_USER_SUCCESS";
export const FETCH_FOSA_USER_FAILURE = "FETCH_FOSA_USER_FAILURE";

export const FETCH_FOSA_MEDICAL_ITEMS_REQUEST = "FETCH_FOSA_MEDICAL_ITEMS_REQUEST"
export const FETCH_FOSA_MEDICAL_ITEMS_SUCCESS = "FETCH_FOSA_MEDICAL_ITEMS_SUCCESS"
export const FETCH_FOSA_MEDICAL_ITEMS_FAILURE = "FETCH_FOSA_MEDICAL_ITEMS_FAILURE"

export const FETCH_FOSA_MEDICAL_SERVICES_REQUEST = "FETCH_FOSA_MEDICAL_SERVICES_REQUEST"
export const FETCH_FOSA_MEDICAL_SERVICES_SUCCESS = "FETCH_FOSA_MEDICAL_SERVICES_SUCCESS"
export const FETCH_FOSA_MEDICAL_SERVICES_FAILURE = "FETCH_FOSA_MEDICAL_SERVICES_FAILURE"

export const FETCH_PREAUTH_REQUEST = "FETCH_PREAUTH_REQUEST";
export const FETCH_PREAUTH_SUCCESS = "FETCH_PREAUTH_SUCCESS";
export const FETCH_PREAUTH_FAILURE = "FETCH_PREAUTH_FAILURE";


export const FETCH_PREAUTHFORM_REQUEST = "FETCH_PREAUTHFORM_REQUEST";
export const FETCH_PREAUTHFORM_SUCCESS = "FETCH_PREAUTHFORM_SUCCESS";
export const FETCH_PREAUTHFORM_FAILURE = "FETCH_PREAUTHFORM_FAILURE";

export const FETCH_PREAUTH_HISTORY_REQUEST = "FETCH_PREAUTH_HISTORY_REQUEST";
export const FETCH_PREAUTH_HISTORY_SUCCESS = "FETCH_PREAUTH_HISTORY_SUCCESS";
export const FETCH_PREAUTH_HISTORY_FAILURE = "FETCH_PREAUTH_HISTORY_FAILURE";

export const GET_PREAUTH_REQUEST = "GET_PREAUTH_REQUEST";
export const GET_PREAUTH_SUCCESS = "GET_PREAUTH_SUCCESS";
export const GET_PREAUTH_FAILURE = "GET_PREAUTH_FAILURE";


export const CREATE_PREAUTH_REQUEST = "CREATE_PREAUTH_REQUEST";
export const CREATE_PREAUTH_SUCCESS = "CREATE_PREAUTH_SUCCESS";
export const CREATE_PREAUTH_FAILURE = "CREATE_PREAUTH_FAILURE";

export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

// Add these new chat-related action types
export const FETCH_CLAIM_CHAT_REQUEST = 'FETCH_CLAIM_CHAT_REQUEST';
export const FETCH_CLAIM_CHAT_SUCCESS = 'FETCH_CLAIM_CHAT_SUCCESS';
export const FETCH_CLAIM_CHAT_FAILURE = 'FETCH_CLAIM_CHAT_FAILURE';
export const CREATE_CLAIM_CHAT_REQUEST = 'CREATE_CLAIM_CHAT_REQUEST';
export const CREATE_CLAIM_CHAT_SUCCESS = 'CREATE_CLAIM_CHAT_SUCCESS';
export const CREATE_CLAIM_CHAT_FAILURE = 'CREATE_CLAIM_CHAT_FAILURE';




